import React from 'react';
import { Grid } from '@mui/material';

import { InfoField } from '@occc/ui-design-system';
import { Count_Products_By } from '@occc/graphql';

import { getTimePeriodText } from './utils/getTimePeriodText';
import { mapTypenameToMemberPurchasedOperator } from './utils/mapTypenameToMemberPurchasedOperator';
import { TransactionsMemberPurchasedOperatorToTitleMap } from './constants';
import { productCountingMap } from '../../constants';
import { Purchase as PurchaseAttribute } from '../../types';
import { formatThreshold } from '../../utils';
import { ProductGroupsChipBox } from '../ProductGroupsChipBox';
import { LocationGroupsInfoField } from '../LocationGroupsInfoField';
import { LocationsInfoField } from '../LocationsInfoField';

export interface IPurchaseProps {
  attribute: PurchaseAttribute;
}

export const formatProductCounting = (
  countProductsBy: Count_Products_By | null | undefined,
): string => (countProductsBy ? productCountingMap[countProductsBy] : '');

export const Purchase: React.FC<IPurchaseProps> = ({ attribute }) => {
  const action = attribute.countProductsBy === Count_Products_By.Quantity ? 'purchase' : 'spend';

  const timePeriodText = getTimePeriodText({
    timeWindow: attribute.timeWindow,
    relativeMonthsBack: attribute.relativeMonthsBack,
    targetMonth: attribute.targetMonth,
    targetYear: attribute.targetYear,
    startDate: attribute.startDate,
    endDate: attribute.endDate,
  });

  const type = mapTypenameToMemberPurchasedOperator(
    attribute.__typename,
    attribute.excludeThreshold,
  );
  const typeTitle = TransactionsMemberPurchasedOperatorToTitleMap[type];

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={2}>
        <InfoField
          label='Count products by'
          value={formatProductCounting(attribute.countProductsBy)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <InfoField
          label={`${action} ${typeTitle}`}
          value={formatThreshold(attribute.threshold ?? 0, attribute.countProductsBy)}
        />
      </Grid>

      <Grid item md={2}>
        <InfoField label='Threshold' value={attribute.excludeThreshold ? 'exclude' : 'include'} />
      </Grid>

      <Grid item>
        <InfoField label='Time period of the purchase' value={timePeriodText} />
      </Grid>
      <Grid item xs={12}>
        <InfoField
          label='Product groups to purchase'
          value={<ProductGroupsChipBox productGroups={attribute.productGroups} />}
          disableTypography
          p={0}
          m={0}
        />
      </Grid>

      {!!attribute.locations?.length && (
        <Grid item xs={12}>
          <LocationsInfoField locations={attribute.locations} />
        </Grid>
      )}

      {!!attribute.locationGroups?.length && (
        <Grid item xs={12}>
          <LocationGroupsInfoField locationGroups={attribute.locationGroups} />
        </Grid>
      )}
    </Grid>
  );
};
